<template>
  <div>
    <Header></Header>
    <Story></Story>
    <Life></Life>
    <Vid></Vid>
    <Honor></Honor>
    <Data></Data>
  </div>
</template>
<script>
import Header from "./header.vue";
import Story from "./story.vue";
import Life from "./life.vue";
import Vid from "./vid.vue";
import Honor from "./honor.vue";
import Data from "./data.vue";
export default {
  data() {
    return {};
  },
  components: {
    Header,
    Story,
    Life,
    Vid,
    Honor,
    Data,
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
</style>